import(/* webpackMode: "eager", webpackExports: ["PostImage"] */ "/vercel/path0/src/app/(main-layout)/blog/(page-layout)/page/[page]/components/post-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/vercel/path0/src/app/(main-layout)/blog/post/[slug]/components/back-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/images/blog-fallback.png");
